import { TextInput, type TextInputProps } from "@mantine/core";
import React from "react";

import styles from "./Week.module.scss";

export const StyledWeek: React.FC<TextInputProps> = ({
  className,
  ...props
}) => (
  <TextInput className={`${styles.styledWeek} ${className ?? ""}`} {...props} />
);
